import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../context/AuthContext';
import './Layout.css';

const Layout = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const { logout } = useAuth();
  const { t, i18n } = useTranslation();
  const location = useLocation();

  const navigation = [
    { path: '/dashboard', name: t('nav.dashboard'), icon: '��' },
    { path: '/tenants', name: 'Firma Yönetimi', icon: '🏢' },
    { path: '/settings', name: t('nav.settings'), icon: '⚙️' },
    { path: '/monitoring', name: t('nav.monitoring'), icon: '📈' },
  ];

  const languages = [
    { code: 'tr', name: t('language.tr'), flag: '🇹🇷' },
    { code: 'en', name: t('language.en'), flag: '🇺🇸' },
    { code: 'de', name: t('language.de'), flag: '🇩🇪' },
  ];

  const handleLogout = () => {
    logout();
  };

  const handleLanguageChange = (languageCode) => {
    i18n.changeLanguage(languageCode);
  };

  return (
    <div className="layout">
      {/* Sidebar */}
      <div className={`sidebar ${sidebarOpen ? 'open' : ''}`}>
        <div className="sidebar-header">
          <h2>ASTOS ERP</h2>
          <p className="system-title">Sistem Yönetimi</p>
          <button 
            className="sidebar-toggle"
            onClick={() => setSidebarOpen(!sidebarOpen)}
          >
            {sidebarOpen ? '✕' : '☰'}
          </button>
        </div>

        <nav className="sidebar-nav">
          {navigation.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={`nav-item ${location.pathname === item.path ? 'active' : ''}`}
              onClick={() => setSidebarOpen(false)}
            >
              <span className="nav-icon">{item.icon}</span>
              <span className="nav-text">{item.name}</span>
            </Link>
          ))}
        </nav>

        {/* Language Selector */}
        <div className="language-selector">
          <h4>{t('language')}</h4>
          <div className="language-options">
            {languages.map((lang) => (
              <button
                key={lang.code}
                className={`language-btn ${i18n.language === lang.code ? 'active' : ''}`}
                onClick={() => handleLanguageChange(lang.code)}
              >
                <span className="flag">{lang.flag}</span>
                <span className="lang-name">{lang.name}</span>
              </button>
            ))}
          </div>
        </div>

        <div className="sidebar-footer">
          <button className="logout-btn" onClick={handleLogout}>
            <span className="nav-icon">🚪</span>
            <span className="nav-text">{t('logout')}</span>
          </button>
        </div>
      </div>

      {/* Main Content */}
      <div className="main-content">
        <header className="header">
          <div className="header-left">
            <button 
              className="menu-toggle"
              onClick={() => setSidebarOpen(!sidebarOpen)}
            >
              ☰
            </button>
            <h1>Sistem Yönetim Paneli</h1>
          </div>
          <div className="header-right">
            <div className="user-info">
              <span>Admin</span>
              <div className="current-language">
                {languages.find(lang => lang.code === i18n.language)?.flag} {i18n.language.toUpperCase()}
              </div>
            </div>
          </div>
        </header>

        <main className="content">
          {children}
        </main>
      </div>

      {/* Overlay for mobile */}
      {sidebarOpen && (
        <div 
          className="sidebar-overlay"
          onClick={() => setSidebarOpen(false)}
        />
      )}
    </div>
  );
};

export default Layout; 